<template>
  <div>
    <div class="flex flex-wrap -mx-2 mb-4">
      <search-input class="mx-2 md:mb-4 max-w-full md:flex-400" />

      <!-- Desktop filters -->
      <div v-for="category in categories"
           :key="category.slug"
           class="hidden md:block px-2 mb-4"
      >
        <search-category-single-desktop :category="category" :show-as-links="!activeCategories.length" />
      </div>

      <div v-if="activeCategories.length" class="hidden md:block px-2 mb-4">
        <button class="btn btn-xs btn-secondary" @click="removeAllCategories">
          {{ clearAllText }}
        </button>
      </div>
    </div>

    <!-- Mobile filters -->

    <search-product-categories-mobile v-if="type === 'product'" />
    <search-recipe-categories-mobile v-if="type === 'recipe'" />
  </div>
</template>

<script>
import { computed, ref } from 'vue'

import searchConfig from '@/compositions/search/SearchConfiguration'
import searchQueryState from '@/compositions/search/SearchQuery'
import SearchRecipeCategoriesMobile from './SearchRecipeCategoriesMobile.vue'
import SearchProductCategoriesMobile from './SearchProductCategoriesMobile.vue'
import SearchCategorySingleDesktop from './SearchCategorySingleDesktop.vue'
import SearchInput from './SearchInput.vue'

export default {
  components: {
    SearchRecipeCategoriesMobile,
    SearchProductCategoriesMobile,
    SearchCategorySingleDesktop,
    SearchInput
  },
  setup() {
    const { getActiveConfig } = searchConfig.searchConfigurationUse()
    const { activeCategories, removeAllCategories } = searchQueryState.searchQueryUse()

    const showFilterOverlay = ref(false)

    return {
      categories: computed(() => getActiveConfig().categories),
      clearAllText: computed(() => getActiveConfig().translations.clearAllText),
      type: computed(() => getActiveConfig().type),
      showFilterOverlay,
      activeCategories,
      removeAllCategories
    }
  }
}
</script>
